import { toFlatField } from '../oasis-types';
export const HealthManagementVersioned = {
    healthManagement: { e1: { alias: 'healthManagement', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
};
export const HealthManagement = toFlatField(HealthManagementVersioned);
